import { createFileRoute } from '@tanstack/react-router'
import { PilotDailyReviewPage } from '~/components/routes/categories/forecastPilot/PilotDailyReviewPage'
import { FORECAST_PILOT_READ } from '~/components/routes/categories/forecastPilot/pilotLabels'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute(
  '/_authenticated/categories/reappro/forecast-pilot_/daily-review',
)({
  staticData: {
    permission: FORECAST_PILOT_READ,
  },
  component: PilotDailyReviewPage,
})
withRoutePermissions(Route)
